import { validateForUI } from 'common/helpers/jsonValidator';

const frequencyUpdateSchema = {
  type: 'object',
  properties: {
    subscription: {
      type: 'object',
      properties: {
        frequency: { type: 'integer', minimum: 1, maximum: 12 }
      },
      required: ['frequency'],
      additionalProperties: false
    }
  },
  required: ['subscription'],
  additionalProperties: false
};

export const validateFrequencyUpdate = (form, frequenciesOffered) => {
  const errors = validateForUI(
    frequencyUpdateSchema,
    form,
    customValidate(form, frequenciesOffered)
  );
  return errors;
};

const customValidate = (form, frequenciesOffered) => {
  const errorArray = [];

  if (!frequenciesOffered.includes(form.subscription.frequency)) {
    const error = {
      field: 'frequency',
      message: 'Selected Frequency is not an allowed value'
    };
    errorArray.push(error);
  }

  return errorArray;
};
